import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import inventoryService from '../../services/inventoryService';
import { Alert, Button, Spinner } from '../UI/Index';
import InventoryList from './InventoryList';
import CreateInventoryModal from '../Inventory/CreateInventoryModal';
import { useAuth } from '../../context/AuthContext';


const Dashboard = () => {
  const [inventories, setInventories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [recordType, setRecordType] = useState('inventory');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInventories = async () => {
      try {
        setLoading(true);
        const response = await inventoryService.getInventories();

        if (response.success) {
          setInventories(response.data || []);
        } else {
          setError(response.message || 'Error al cargar inventarios');
        }
      } catch (err) {
        setError(err.message || 'Error al cargar inventarios');
      } finally {
        setLoading(false);
      }
    };

    fetchInventories();
  }, []);

  const { roles } = useAuth();

  const handleOpenCreateModal = (type) => {
    setRecordType(type);
    setShowCreateModal(true);
  };

  const handleCloseCreateModal = () => {
    setShowCreateModal(false);
  };

  const handleInventoryCreated = async () => {
    setShowCreateModal(false);

    try {
      setLoading(true);
      const response = await inventoryService.getInventories();

      if (response.success) {
        setInventories(response.data || []);
      }
    } catch (err) {
      setError(err.message || 'Error al recargar inventarios');
    } finally {
      setLoading(false);
    }
  };

  const handleViewInventory = (inventoryId) => {
    navigate(`/inventory/${inventoryId}`);
  };


  return (
    <div className="container mx-auto">
      <div className="items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <div className="flex item s-center gap-2">
          <Button type="primary" onClick={() => handleOpenCreateModal('inventory')}>
            <b>Crear inventario</b>
          </Button>
          {!roles.isAdmin && (
            <Button type="primary" className="bg-orange-500 hover:bg-orange-600" onClick={() => handleOpenCreateModal('expired')}>
              <b>Crear Caducados</b>
            </Button>)
          }
        </div>
      </div>

      {error && <Alert type="error" message={error} onClose={() => setError('')} />}

      <div className="p-4 bg-white rounded-lg shadow-md">
        <h2 className="mb-4 text-xl font-semibold">Inventarios</h2>

        {loading ? (
          <div className="flex items-center justify-center py-8">
            <Spinner size="lg" />
          </div>
        ) : inventories.length === 0 ? (
          <div className="py-4 text-center text-gray-500">
            No hay inventarios disponibles.
          </div>
        ) : (
          <InventoryList
            inventories={inventories}
            onViewInventory={handleViewInventory}
          />
        )}
      </div>

      {showCreateModal && (
        <CreateInventoryModal
          isOpen={showCreateModal}
          onClose={handleCloseCreateModal}
          onInventoryCreated={handleInventoryCreated}
          recordType={recordType}
        />
      )}
    </div>
  );
};

export default Dashboard;